import * as React from 'react';
import { FI18n } from '@freelog/tools-lib';
import FComponentsLib from '@freelog/components-lib';
import FTooltip from '@/components/FTooltip';
import styles from './index.less';
import type { SearchResult } from './types';

interface SearchPanelProps {
  results: SearchResult[];
  subjectType: string;
  showAddNewType: boolean;
  onSelect: (v: { value: string; labels: string[] }) => void;
  onBack: () => void;
}

function SearchPanel({ results, subjectType, showAddNewType, onSelect, onBack }: SearchPanelProps) {
  if (results.length === 0) {
    return (
      <div className={styles.emptySearch}>
        <FComponentsLib.FContentText
          text={FI18n.i18nNext.t('selectresourcetype_noresaultfound_msg')}
          type="normal"
          style={{ color: '#666' }}
        />
        {subjectType === 'resource' && (
          <>
            <div style={{ height: 10 }} />
            <div className={styles.emptySearchHint}>
              <FComponentsLib.FContentText
                text={FI18n.i18nNext.t('selectresourcetype_noresaultfound_msg2')}
                type="additional2"
              />
              {showAddNewType && (
                <FComponentsLib.FTextBtn type="primary" onClick={onBack}>
                  {FI18n.i18nNext.tAuto('selectresourcetype_noresaultfound_btn_back')}
                </FComponentsLib.FTextBtn>
              )}
            </div>
          </>
        )}
      </div>
    );
  }

  return (
    <>
      {results.map((aco, i) => (
        <div
          key={i}
          className={styles.autoCompleteOption2}
          onClick={() => onSelect({ value: aco.value, labels: aco.labels })}
        >
          <FTooltip
            styles={{ body: { width: 'fit-content' } }}
            title={aco.labels.join('/')}
            mouseEnterDelay={0.5}
          >
            <span>{aco.labels.join('/')}</span>
          </FTooltip>
          <label>
            {FI18n.i18nNext.tAuto('createresource_selectresourcetype_input_resourceqty', {
              ResourceQty: aco.count,
            })}
          </label>
        </div>
      ))}
    </>
  );
}

export default SearchPanel;
